module.exports = __webpack_public_path__ + "static/img/12.902382d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/12/sp/12.png
// module id = KUGC
// module chunks = 0